module.exports = __webpack_public_path__ + "img/uatp.a28af3b.png";